import * as React from "react";
import styled from "styled-components";

import Text from "../../elements/Text";

const calcPerc = (currentTime: number, duration: number) => {
  return (currentTime / duration) * 100;
};

const calcSeconds = (width: number, pos: number, duration: number) => {
  return Math.floor((pos / width) * duration);
};

const minMax = (min: number, max: number, value: number) => {
  if (value > max) {
    return max;
  }
  if (value < min) {
    return min;
  }
  return value;
};

const formatSeconds = (seconds: number): string => {
  return [Math.floor(seconds / 60), Math.floor(seconds % 60)]
    .map(x => x.toString())
    .map(x => (x.length === 1 ? `0${x}` : x))
    .join(":");
};

const Container = styled.div`
  position: absolute;
  bottom: 12px;
  left: 16px;
  right: 16px;
`;

const BarOuter = styled.div`
  position: relative;
  height: 10px;
  width: 100%;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  overflow: hidden;
`;

const BarInner = styled.div`
  height: 100%;
  background-color: white;
`;

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.25em;
`;

type Props = {
  currentTime: number;
  duration: number;
  onTimeChange: (seconds: number) => void;
};

class TimeBar extends React.Component<Props> {
  mouseDown: boolean = false;
  bar = React.createRef<HTMLDivElement>();

  state = {
    tmpTime: null
  };

  handleMouseDown = () => {
    this.mouseDown = true;

    document.addEventListener("mousemove", this.handleMove);
    document.addEventListener("mouseup", this.handleUp);
  };

  handleUp = (evt: any) => {
    this.mouseDown = false;
    document.removeEventListener("mousemove", this.handleMove);
    document.removeEventListener("mouseup", this.handleUp);

    this.setState({ tmpTime: null }, () => {
      this.props.onTimeChange(this.getCurrentTimeFromPos(evt.clientX));
    });
  };

  getCurrentTimeFromPos = (x: number) => {
    const { width, left } = this.bar.current!.getBoundingClientRect();

    const { duration } = this.props;

    return minMax(0, duration, calcSeconds(width, x - left, duration));
  };

  handleMove = (evt: any) => {
    this.setState({
      tmpTime: this.getCurrentTimeFromPos(evt.clientX)
    });
  };

  render() {
    const { currentTime, duration } = this.props;
    const { tmpTime } = this.state;

    return (
      <Container>
        <BarOuter ref={this.bar} onMouseDown={this.handleMouseDown}>
          <BarInner
            style={{ width: `${calcPerc(tmpTime || currentTime, duration)}%` }}
          />
        </BarOuter>
        <Bottom>
          <Text c="white" fs={-2}>
            {formatSeconds(tmpTime || currentTime)}
          </Text>
          <Text c="white" fs={-2}>
            {formatSeconds(duration)}
          </Text>
        </Bottom>
      </Container>
    );
  }
}

export default TimeBar;
